import { useTranslation } from "@refinedev/core";
import { Calendar } from "components/customIcons";
import DateTimePicker from "components/datetimePicker";
import { Label } from "components/label";
import { IBuildEventPageForm } from "interfaces";
import { get } from "lodash";
import moment from "moment";
import { Controller, useFormContext } from "react-hook-form";

export const TicketOnSale = ({ isEdit, id }: { isEdit: boolean, id: string | null }) => {
  const { translate } = useTranslation();
  const {
    getFieldState,
    getValues,
    control,
    formState: { errors },
  } = useFormContext<IBuildEventPageForm>(); // retrieve all hook methods

  return (
    <div className="box-container">
      {!isEdit ? (
        (!getFieldState("ticket_on_sale").isTouched ||
        errors["ticket_on_sale"]) && !id ? (
          <p>
            {translate("eventSetup.eventInfo.ticketSalePeriod.note")}
          </p>
        ) : (
          <div className="w-full flex flex-row items-start gap-x-2">
            <div className="w-40 shrink-0 flex flex-row items-center gap-x-2">
              <Calendar />
              {translate("eventSetup.eventInfo.ticketSalePeriod.registrationDate")}:
            </div>
            <p>
              {moment(
                getValues("ticket_on_sale").open_registration_date
              ).format("HH:mm DD/MM/YYYY")}{" "}
              -{" "}
              {moment(
                getValues("ticket_on_sale").close_registration_date
              ).format("HH:mm DD/MM/YYYY")}
            </p>
          </div>
        )
      ) : (
        <div className="grid gap-x-4 gap-y-6 sm:grid-cols-6 lg:gap-x-6">
          <div className="sm:col-span-3">
            <Label
              required
              id="ticket_on_sale.open_registration_date"
              name={translate("eventSetup.eventInfo.ticketSalePeriod.openRegistrationDate")}
            />
            <Controller
              control={control}
              name="ticket_on_sale.open_registration_date"
              render={({ field: { onChange, value = "" } }) => {
                return (
                  <DateTimePicker
                    id="ticket_on_sale.open_registration_date"
                    placeholder={translate("eventSetup.eventInfo.ticketSalePeriod.openRegistrationDate")}
                    className="bg-white"
                    error={get(
                      errors,
                      `ticket_on_sale.open_registration_date.message`,
                      ""
                    )}
                    value={value}
                    onChange={(date: any) => date === null ? onChange("") : onChange(moment(date).format("YYYY-MM-DD HH:mm:ss"))}
                  />
                );
              }}
            />
            {get(errors, `ticket_on_sale.open_registration_date`, "") ? (
              <p className="error-text">
                <span className="font-medium">
                  {get(
                    errors,
                    `ticket_on_sale.open_registration_date.message`,
                    ""
                  )}
                </span>
              </p>
            ) : null}
          </div>
          <div className="sm:col-span-3">
            <Label
              required
              id="ticket_on_sale.close_registration_date"
              name={translate("eventSetup.eventInfo.ticketSalePeriod.closeRegistrationDate")}
            />
            <Controller
              control={control}
              name="ticket_on_sale.close_registration_date"
              render={({ field: { onChange, value = "" } }) => {
                return (
                  <DateTimePicker
                    id="ticket_on_sale.close_registration_date"
                    placeholder={translate("eventSetup.eventInfo.ticketSalePeriod.closeRegistrationDate")}
                    className="bg-white"
                    error={get(
                      errors,
                      `ticket_on_sale.close_registration_date.message`,
                      ""
                    )}
                    value={value}
                    onChange={(date: any) => date === null ? onChange("") : onChange(moment(date).format("YYYY-MM-DD HH:mm:ss"))}
                  />
                );
              }}
            />
            {get(errors, `ticket_on_sale.close_registration_date`, "") ? (
              <p className="error-text">
                <span className="font-medium">
                  {get(
                    errors,
                    `ticket_on_sale.close_registration_date.message`,
                    ""
                  )}
                </span>
              </p>
            ) : null}
          </div>
        </div>
      )}
    </div>
  );
};
